import { getCustomerClaims, getCustomerPolicies } from '@/service/customerServices';
import { buildClaimCases } from '@/utils/claimCases';
import type { ClaimCase } from '@/types/claim';
import { useDashboardQuery } from './useDashboardQuery';

const EMPTY: ClaimCase[] = [];

/** The customer's claims for the Claims tab and claim details, with loading/error state. */
export function useCustomerClaims() {
  const { data, ...rest } = useDashboardQuery(
    async (demo) => {
      if (import.meta.env.DEV && demo) return (await import('@/pages/dev/demoData')).demoClaimCases();
      const [claims, policies] = await Promise.all([
        getCustomerClaims(),
        // Policies only add plan names; don't fail the page without them.
        getCustomerPolicies().catch(() => []),
      ]);
      return buildClaimCases(claims, policies);
    },
    EMPTY,
    'We couldn’t load your claims. Please try again.',
  );
  return { claims: data, ...rest };
}
